import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { getTrialLeftDaysCount } from '../helpers/App';
import { userIsAdmin } from '../helpers/Auth';

import ErrorBoundary from './ErrorBoundary';

const TrialNotice = ({
  client,
  isInTrial,
  features,
  className,
  feature,
}) => {
  const intl = useIntl();

  if (!isInTrial || !feature) {
    return null;
  }

  const lockedFeature = features.find(f => (f.slug === feature));
  const plan = lockedFeature && lockedFeature.plans
    .reduce((lowest, featurePlan) => (featurePlan.position < lowest.position ?
      featurePlan : lowest), lockedFeature.plans[0]);
  const daysLeftTrial = getTrialLeftDaysCount(client);

  return (
    <ErrorBoundary>
      <div className={`content-wrapper trial-notice trial-notice-${plan.slug} ${className}`}>
        <div className="trial-notice-content">
          <div className="trial-notice-plan">
            <i className="fas fa-arrow-up" />
            {plan.name}
          </div>
          <div className="trial-notice-days-left">
            {intl.formatMessage({
              defaultMessage: 'You have <span>{days} {days, plural, one {day} other {days}}</span> left to use this.',
            }, {
              days: daysLeftTrial,
              span: (msg) => (<span className="trial-days-left">{msg}</span>),
            })}
            {userIsAdmin && (
              <Link to="/admin/settings/subscription" target="_blank" className="upgrade-plan-button-link ml-2">
                {intl.formatMessage({ defaultMessage: 'Upgrade now to keep access →' })}
              </Link>
            )}
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

const mapStateToProps = state => ({
  client: state.Auth.profile?.client,
  isInTrial: state.Auth.profile?.client?.is_in_trial,
  features: state.App.features,
});

TrialNotice.propTypes = {
  client: PropTypes.object.isRequired,
  isInTrial: PropTypes.bool.isRequired,
  features: PropTypes.array.isRequired,
  className: PropTypes.string,
  feature: PropTypes.string.isRequired,
};

TrialNotice.defaultProps = {
  className: '',
};

export default connect(mapStateToProps)(TrialNotice);
